/* Tira o zoom automatico do iOS nos campos do popup do Shopify Forms (Match Day).
 *
 * O Safari do iPhone da zoom em qualquer campo com font-size abaixo de 16px, e os
 * campos do app vem com 14px. O app renderiza dentro de um shadow DOM, entao o CSS do
 * tema nao alcanca: a unica forma de estilizar por fora e injetar um <style> dentro do
 * proprio shadow root, que e o que este script faz.
 *
 * A regra vale so em tela de toque (pointer: coarse). No desktop o formulario continua
 * exatamente como estava.
 *
 * Se o app mudar de nome de elemento ou fechar o shadow root, o script simplesmente nao
 * acha nada e sai quieto - a loja segue normal, so volta o zoom.
 *
 * === O QUE MUDOU EM 2026-09-04 (so desempenho, nada de comportamento) ===
 * A versao anterior procurava o elemento com document.querySelectorAll("*") - a lista
 * de TODOS os nos da pagina - e repetia essa varredura a cada 150ms, ate 100 vezes,
 * enquanto o shadow root nao existisse. Medido com a CPU 4x mais lenta (celular real,
 * 04/09/2026): 10 varreduras completas e 94ms de thread principal so para achar UM
 * elemento; era o segundo maior consumidor de thread da home depois do carregador de
 * pixels.
 *
 * Agora a busca no documento inteiro acontece DUAS vezes (no carregamento do script e
 * no load), e a espera pelo shadow root passa a olhar apenas os elementos ja
 * encontrados, em vez do documento. O <style> injetado, o CSS, a marca, a janela de
 * espera (100 x 150ms) e o alvo sao exatamente os mesmos - o resultado na tela e
 * identico.
 */
(function () {
  "use strict";

  var MARCA = "data-md-nozoom";
  var CSS =
    "@media (pointer: coarse){" +
    "input:not([type=checkbox]):not([type=radio]):not([type=range])," +
    "textarea,select{font-size:16px !important}}";

  function injetar(raiz) {
    if (!raiz || raiz.querySelector("style[" + MARCA + "]")) return false;
    var s = document.createElement("style");
    s.setAttribute(MARCA, "1");
    s.textContent = CSS;
    raiz.appendChild(s);
    return true;
  }

  function ehAlvo(el) {
    return el && el.nodeType === 1 && el.tagName.indexOf("SHOPIFY-FORMS") === 0;
  }

  /* elementos do app ja vistos que ainda nao tem shadow root */
  var pendentes = [];
  var timer = null;

  /* devolve true quando o style ja pode ser injetado (shadow root existe) */
  function tentar(el) {
    if (!el || !el.shadowRoot) return false;
    injetar(el.shadowRoot);
    return true;
  }

  /*
    O elemento do app entra na pagina antes do shadow root existir, e o shadow root
    antes dos campos. Injetar cedo cobre tudo: o <style> vale pro que vier depois.
  */
  function acompanhar(el) {
    if (!ehAlvo(el)) return;
    if (tentar(el)) return;
    for (var i = 0; i < pendentes.length; i++) if (pendentes[i] === el) return;
    pendentes.push(el);
    insistir();
  }

  /* A espera olha SO os elementos pendentes - nao o documento. Mesma janela de antes:
     ate 100 tentativas de 150ms, e o timer morre quando nao ha mais o que esperar. */
  function insistir() {
    if (timer || !pendentes.length) return;
    var tentativas = 0;
    timer = setInterval(function () {
      tentativas++;
      for (var i = pendentes.length - 1; i >= 0; i--) {
        if (tentar(pendentes[i])) pendentes.splice(i, 1);
      }
      if (!pendentes.length || tentativas > 100) {
        clearInterval(timer);
        timer = null;
      }
    }, 150);
  }

  /* varredura do documento: cara, entao acontece so no inicio e no load */
  function varrerDocumento() {
    var todos = document.getElementsByTagName("*");
    for (var i = 0; i < todos.length; i++) acompanhar(todos[i]);
  }

  varrerDocumento();

  /* O app carrega em algum momento depois do HTML. Observo as insercoes e acompanho o
     elemento assim que ele aparece, sem varrer a pagina de novo. */
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (mutacoes) {
      for (var i = 0; i < mutacoes.length; i++) {
        var novos = mutacoes[i].addedNodes;
        for (var j = 0; j < novos.length; j++) {
          var n = novos[j];
          if (!n || n.nodeType !== 1) continue;
          if (ehAlvo(n)) {
            acompanhar(n);
            continue;
          }
          /* o elemento pode vir dentro de um bloco inserido de uma vez: aqui a busca
             fica limitada a esse bloco, que e minusculo perto do documento */
          if (n.getElementsByTagName) {
            var dentro = n.getElementsByTagName("*");
            for (var k = 0; k < dentro.length; k++) {
              if (ehAlvo(dentro[k])) acompanhar(dentro[k]);
            }
          }
        }
      }
    });
    obs.observe(document.documentElement || document, { childList: true, subtree: true });
  }

  /* Rede de seguranca: se o elemento entrou por um caminho que o observer nao pegou,
     uma ultima varredura no load resolve. */
  window.addEventListener("load", varrerDocumento);
})();
